import { AnalyticsUserEvent } from '@fruitful/types';
import { useFeatureGate } from '@statsig/expo-bindings';
import { FullScreenSpinner, SafeAreaView } from 'smoothie';

import { useViewEvents } from '../../../events/hooks/useViewEvents';
import { FeatureFlags } from '../../../feature-flags/FeatureFlags';
import { track } from '../../../logger/Logger';
import { useMoneyMapWorkflow } from '../../hooks/useMoneyMapWorkflow';
import { GoWorkflowStepType } from '../../types/GoWorkflow';
import { GoWorkflowHeader } from '../GoWorkflowHeader';
import MoneyMap from '../money-map/MoneyMap';
import { MoneyMapRedesign } from '../money-map/MoneyMapRedesign';

const MoneyMapGoWorkflow = () => {
    const { value: enableMoneySystemTab } = useFeatureGate(
        FeatureFlags.ENABLE_MONEY_SYSTEM_TAB,
    );
    const { trackViewOnce } = useViewEvents();

    const {
        isLoadingMoneyMap,
        moneyMap,
        isLoadingCompleteness,
        getNextStep,
        proceedForward,
    } = useMoneyMapWorkflow();
    const nextStep = getNextStep(GoWorkflowStepType.MONEY_MAP);

    if (isLoadingCompleteness || isLoadingMoneyMap) {
        return <FullScreenSpinner />;
    }

    trackViewOnce('Roadmap/Go/MoneyMap');

    const submitButtonText =
        nextStep?.type === GoWorkflowStepType.CASH_ACCOUNTS ||
        nextStep?.type === GoWorkflowStepType.CARD_ACCOUNTS ||
        nextStep?.type === GoWorkflowStepType.APEX_ACCOUNTS
            ? 'Continue'
            : nextStep?.type === GoWorkflowStepType.INCOME_SPLIT
              ? 'Review Income Split rules'
              : 'Done';

    const MoneyMapComponent = enableMoneySystemTab
        ? MoneyMapRedesign
        : MoneyMap;

    return (
        <SafeAreaView edges={['left', 'right', 'bottom']}>
            <GoWorkflowHeader
                stepType={GoWorkflowStepType.MONEY_MAP}
                title="Money Map"
            />
            <MoneyMapComponent
                moneyMap={moneyMap}
                showSubmitButton={nextStep != null}
                submitButtonText={submitButtonText}
                onPressSubmit={() => {
                    track(
                        AnalyticsUserEvent.MONEY_MAP_WORKFLOW_STEP_SUBMIT_REVIEW,
                    );
                    // TODO await refetchMoneyMapCompleteness(); before proceeding
                    proceedForward(GoWorkflowStepType.MONEY_MAP);
                }}
                {...(enableMoneySystemTab && { mode: 'go-flow' as const })}
            />
        </SafeAreaView>
    );
};

export default MoneyMapGoWorkflow;
